import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject, Subject } from 'rxjs';
@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss'],
  standalone: false
})
export class SupportComponent implements OnInit {
  @ViewChild('tatModal') tatModal!: TemplateRef<any>;
	bucketurl = environment.bucketUrl;
  isLoading: Subject<boolean> = new Subject<boolean>();

  constructor(private dialog: MatDialog, private http: HttpClient) { }
  ngOnInit(): void {
  }


  // Gmail compose link helper (subject/body optional)
  gmailLink(to: string, subject: string = '', body: string = ''): string {
    const p = new URLSearchParams({
      view: 'cm',
      fs: '1',
      to,
      su: subject,
      body
    });
    return `https://mail.google.com/mail/?${p.toString()}`;
  }


  openTatModal(): void {
    this.dialog.open(this.tatModal, {
    width: '1024px',
    maxWidth: '95vw',
    maxHeight:'90vh',
    panelClass: 'tat-dialog-panel'
    });
  }

  closeDialog(){
    this.dialog.closeAll();
  }

   downloadFile(url: string) {
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.http.get(url, { responseType: 'blob' }).subscribe((blob) => {
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = url.split('/').pop() || 'download.pdf';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

}